// Wire types for the sync layer. Per plan/02 §SDK abstraction layer:
// nothing outside `src/features/sync/` imports the Pocketbase SDK; every
// consumer goes through the `SyncClient` interface, so a future Postgres
// or generic-REST backend would be a drop-in.

export type CollectionName = 'profiles' | 'routines' | 'tasks' | 'progress' | 'profile_routines';

// Common shape for every record the sync layer round-trips. Concrete
// rows extend this with their own snake_case payload fields.
export interface RemoteRecord {
  id: string;
  family: string;
  // Pocketbase auto-managed timestamp (ISO 8601). The conflict merge
  // compares this against local `updatedAt` for last-writer-wins.
  updated: string;
  [key: string]: unknown;
}

export type SubscribeEvent =
  | { action: 'create' | 'update'; record: RemoteRecord }
  | { action: 'delete'; record: { id: string } };

// Thrown when `authWithSyncCode` rejects with an auth-level failure
// (wrong code, family record removed, JWT expired). The UI maps this
// to a Finnish "Koodia ei tunnistettu" — see plan/03 §Sync screen.
export class SyncAuthError extends Error {
  constructor(message: string = 'auth failed') {
    super(message);
    this.name = 'SyncAuthError';
  }
}

// Thrown by the SyncClient when the server permanently rejected a
// write (PB 400 — bad id shape, schema-validator failure, missing
// required field). The outbox uses this to decide "drop, don't retry"
// instead of looping forever like #12. Carries the raw error envelope
// from PB so logs can show which field was bad.
export class SyncBadRequestError extends Error {
  constructor(
    public readonly data: unknown,
    message: string = 'bad request',
  ) {
    super(message);
    this.name = 'SyncBadRequestError';
  }
}
